/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddArticleToSalesWrapRequest
 */
export interface AddArticleToSalesWrapRequest {
    /**
     * ID des Artikels
     * @type {string}
     * @memberof AddArticleToSalesWrapRequest
     */
    articleId: string;
    /**
     * Seriennummer des Artikels
     * @type {string}
     * @memberof AddArticleToSalesWrapRequest
     */
    serialNumber?: string;
    /**
     * Charge des Artikels
     * @type {string}
     * @memberof AddArticleToSalesWrapRequest
     */
    batch?: string;
    /**
     * Mindesthaltbarkeitsdatum (YYYY-MM-DD)
     * @type {Date}
     * @memberof AddArticleToSalesWrapRequest
     */
    bestBeforeDate?: Date;
    /**
     * Herstellungsdatum (YYYY-MM-DD)
     * @type {Date}
     * @memberof AddArticleToSalesWrapRequest
     */
    productionDate?: Date;
}

/**
 * Check if a given object implements the AddArticleToSalesWrapRequest interface.
 */
export function instanceOfAddArticleToSalesWrapRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "articleId" in value;

    return isInstance;
}

export function AddArticleToSalesWrapRequestFromJSON(json: any): AddArticleToSalesWrapRequest {
    return AddArticleToSalesWrapRequestFromJSONTyped(json, false);
}

export function AddArticleToSalesWrapRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddArticleToSalesWrapRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'articleId': json['articleId'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'bestBeforeDate': !exists(json, 'bestBeforeDate') ? undefined : (new Date(json['bestBeforeDate'])),
        'productionDate': !exists(json, 'productionDate') ? undefined : (new Date(json['productionDate'])),
    };
}

export function AddArticleToSalesWrapRequestToJSON(value?: AddArticleToSalesWrapRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'articleId': value.articleId,
        'serialNumber': value.serialNumber,
        'batch': value.batch,
        'bestBeforeDate': value.bestBeforeDate === undefined ? undefined : (value.bestBeforeDate.toISOString().substr(0,10)),
        'productionDate': value.productionDate === undefined ? undefined : (value.productionDate.toISOString().substr(0,10)),
    };
}

